/**
 * The TVL line beside an APR on Pools and Farms (site review 59 #5, 2026-10-07): APRs of 134 % to 11,698 % sat on a few hundred dollars
 * of stake with nothing next to them. "TVL $254", "TVL $1.24K", "TVL $12.3K", "TVL $1.2M"; an unknown value is a dash, never a $0.
 */
export const TVL_HINT = 'Total value staked, in USD. The APR falls as more value is staked.'

/** the app's "no value" placeholder */
const NO_VALUE = '—'

export function formatTvl(usd: number | null | undefined): string {
  if (usd === null || usd === undefined || !Number.isFinite(usd) || usd < 0) return `TVL ${NO_VALUE}`
  if (usd < 1000) return `TVL $${Math.round(usd).toLocaleString('en-US')}`
  const compact = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: usd < 10_000 ? 2 : 1 }).format(usd)
  return `TVL $${compact}`
}

/** Staked value of a pool: tokens staked x the staking token's USD price; unknown when the price is not known (never priced at 0). */
export function poolTvlUsd(totalStakedTokens: number | null | undefined, stakingTokenPriceUsd: number | null | undefined): number | null {
  if (totalStakedTokens === null || totalStakedTokens === undefined || !Number.isFinite(totalStakedTokens)) return null
  if (!stakingTokenPriceUsd || !Number.isFinite(stakingTokenPriceUsd) || stakingTokenPriceUsd <= 0) return null
  return totalStakedTokens * stakingTokenPriceUsd
}
